import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '@finra/rampdi-forms-common';
import { isJsonParsable } from '../../utils/parseCheck.utils';
import { DisplayRulesService } from '../../services/display-rules.service';

@Component({
  selector: 'app-error-route',
  templateUrl: './error-route.component.html',
  styleUrls: ['./error-route.component.scss'],
})
export class ErrorRouteComponent implements OnInit {
  error: any;

  constructor(
    private ls: LoadingService,
    private route: Router,
    private DS: DisplayRulesService,
  ) {}

  ngOnInit(): void {
    this.ls.setLoading(false);
    if (history && history.state && history.state.error && history.state.error.message) {
      this.error =
        history.state.error.message ||
        (isJsonParsable(history.state.error)
          ? JSON.parse(history.state.error.message)
          : 'This MU1 form is no longer available.');
    } else {
      this.error = 'This MU1 form is no longer available.';
    }
    console.log('After parse, the error obj', this.error);
    if (this.route.url.includes('error')) {
      this.DS.navigationError.next(true);
    }
  }
}
